var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 10,
  viewBox: "0 0 14 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14 7V0h-2v5H3.33l2.134-1.5v-.508A.99.99 0 0 0 4.471 2h-.508L.31 5.321a.897.897 0 0 0 0 1.358L3.963 10h.508a.99.99 0 0 0 .993-.992V8.5L3.33 7z"
})));
export default SvgEnter;